import OurPracticeAreas from  './OurPracticeAreas';
import WhoWeAre from './WhoWeAre';
import GetInTouch from './GetInTouch';

const Main = () =>  (
    <div className="main-bg">
        <OurPracticeAreas />
        <WhoWeAre />
        <GetInTouch />      
    </div>    
);
    
export default Main;